import { cn } from '../../lib/cn';
import type { PromptRow } from '../../platformadmin/framework';

type Props = { prompts?: PromptRow[] };

function statusColor(status: string) {
  switch (status) {
    case 'published': return 'bg-success-100 text-success-700 dark:bg-success-950 dark:text-success-300';
    case 'testing': return 'bg-warning-100 text-warning-700 dark:bg-warning-950 dark:text-warning-300';
    default: return 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400';
  }
}

export function PromptGovernancePanel({ prompts = [] }: Props) {
  return (
    <div className="space-y-2">
      {prompts.map((p) => (
        <div key={p.scope} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div>
            <p className="text-sm font-medium">{p.scope}</p>
            <p className="text-xs text-slate-500">{p.version} · {p.tests} tests passed</p>
          </div>
          <span className={cn('shrink-0 rounded-full px-2 py-0.5 text-xs font-medium capitalize', statusColor(p.status))}>
            {p.status}
          </span>
        </div>
      ))}
    </div>
  );
}
